import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { RoiReadModel } from '~/domain/readmodels/StructureSetReadModel';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import { validateStructureName } from '~/utils/validation';

/**
 * Hook that provides a validation function for structure names.
 * Checks against the current structure set's existing names,
 * excluding the given ROI's own name.
 */
export default function useStructureNameValidation(roi: RoiReadModel) {
    const currentStructureSet = useRecoilValue(currentStructureSetState);

    const validate = useCallback(
        (name: string): string | null => {
            if (!currentStructureSet) {
                return 'No structure set';
            }
            const siblingNames = currentStructureSet.roiArray
                .map((s) => s.name)
                .filter((n) => n !== roi.name);
            const [isValid, error] = validateStructureName(name, siblingNames);
            return isValid ? null : error;
        },
        [currentStructureSet, roi.name]
    );

    return validate;
}
